import moment from "moment";
import { getApiInstance } from "../../AppService";
import {
  ORDER_BY_CITY,
  ORDER_BY_TYPE,
  ORDER_REPORT_AVG,
  ORDER_SUMMARY_ANALYSIS,
} from "../../constant";
import { getGeoPointApi } from "../BusinessOnboard/BusinessOnboardingAPI";

export const getOrderSummaryAnalysis = async ({ businessId, params }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });

    const response = await instance.get(ORDER_SUMMARY_ANALYSIS, { params });

    console.log("ORDER_SUMMARY_ANALYSIS:", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getOrderReportByCity = async (businessId) => {
  const currentYear = moment().year();
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });

    const response = await instance.get(ORDER_BY_CITY, {
      params: {
        from: moment(`2022-01-01`).startOf("day").valueOf(),
        to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
      },
    });

    // const pincodeArray = response?.data?.details?.slice(0, 5);
    const updatedArray = [...response?.data?.details];

    for (let i = 0; i < Math.min(5, updatedArray.length); i++) {
      const coOrdinateRes = await getGeoPointApi(updatedArray[i].pincode);

      if (coOrdinateRes?.results?.length > 0) {
        const { lat, lng } = coOrdinateRes?.results[0]?.geometry?.location;
        updatedArray[i] = { ...updatedArray[i], lat, lng }; // Add coordinates
      }

      console.log("ORDER_BY_CITY_1", coOrdinateRes);
    }

    console.log("ORDER_BY_CITY:", response.data, updatedArray);
    return { details: updatedArray || [] };
  } catch (error) {
    console.log(error);
  }
};

export const getOrderReportByType = async (businessId) => {
  const currentYear = moment().year();
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });

    const response = await instance.get(ORDER_BY_TYPE, {
      params: {
        from: moment(`2022-01-01`).startOf("day").valueOf(),
        to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
      },
    });

    console.log("ORDER_BY_TYPE:", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getOrderReportAvg = async (businessId) => {
  const currentYear = moment().year();
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });

    const response = await instance.get(ORDER_REPORT_AVG, {
      params: {
        from: moment(`2022-01-01`).startOf("day").valueOf(),
        to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
      },
    });

    console.log("ORDER_REPORT_AVG:", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
